<template>
  <vs-list class="pb-20">
    <vs-list-item v-for="item in list" :key="item.id"
                  class="px-5 py-3 border-0"
                  :title="item.title"
                  :subtitle="resolveSubtitle(item.subtitle)">

      <base-button v-if="item.routeDetails"
                   variant="bordered"
                   class="px-8"
                   :router-link="item.routeDetails"
      >
        Show
      </base-button>
      <span v-else-if="item.text" class="text-gray text-sm">
        {{ item.text }}
      </span>

    </vs-list-item>
  </vs-list>
</template>

<script>

const CHAR_LIMIT = 45

export default {
  name: 'UsagesList',
  props: {
    list: {
      type: Array,
      required: true
    }
  },

  methods: {
    resolveSubtitle(subtitle) {
      return subtitle.length > CHAR_LIMIT ? subtitle.substring(0, CHAR_LIMIT) + '...' : subtitle
    }
  }
}
</script>
